export const formatNumber = (number: number): string => {
  return number.toLocaleString();
};

export const numberToPercentage = (number: number): string => {
  return number.toString() + '%';
};
